import Layout from '@/layout/index.vue'
import { CommonMudule } from '@/store/modules/common'
import { UserModule } from '@/store/modules/user'
import { Route } from 'vue-router'
import { parse, ParsedQs } from 'qs'
export const constRoutes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: {
      hidden: true,
      activeMenu: '/login',
      sort: 1,
      code: '01'
    }
  },
  {
    path: '/life',
    component: () => import(/* webpackChunkName: "life" */ '../../views/newPension/pensionCard/lifeProduct/index.vue'),
    meta: {
      hidden: true,
      activeMenu: '/life',
      sort: 2
    }
  },
  {
    path: '/investPro',
    component: () => import(/* webpackChunkName: "investPro" */ '../../views/newPension/pensionCard/investCard/index.vue'),
    meta: {
      hidden: true,
      activeMenu: '/investCard',
      sort: 3
    }
  },
  {
    path: '/investPro/edit',
    component: () => import(/* webpackChunkName: "/investPro/edit" */ '../../views/newPension/pensionCard/investCard/edit.vue'),
    meta: {
      hidden: true,
      activeMenu: '/investCard',
      sort: 4
    }
  },
  {
    path: '/investPro/outPage',
    component: () => import(/* webpackChunkName: "/investPro/outPage" */ '@/views/newPension/pensionCard/investCard/outPage.vue'),
    meta: {
      hidden: true,
      activeMenu: '/investCard',
      sort: 5
    }
  },
  {
    path: '/annuityProduct',
    component: () => import(/* webpackChunkName: "annuityProduct" */ '@/views/newPension/pensionCard/annuityProduct/index.vue'),
    meta: {
      hidden: true,
      activeMenu: '/annuityProduct',
      sort: 6
    }
  },
  {
    path: '/economyIndex',
    component: () => import(/* webpackChunkName: "economyIndex" */ '@/views/economyIndex/index.vue'),
    meta: {
      hidden: true,
      title: '经济指标',
      activeMenu: '/economyIndex',
      sort: 7
    }
  },
  {
    path: '/userSelect',
    component: () => import(/* webpackChunkName: "userSelect" */ '@/views/login/user/index.vue'),
    meta: { hidden: true, activeMenu: '/userSelect', sort: 8 }
  },
  {
    path: '/',
    redirect: '/system',
    component: Layout,
    resourceId: '10',
    parentId: null,
    meta: {
      title: '首页',
      icon: 'home',
      activeMenu: '/system',
      sort: 9
    },
    children: [
      {
        path: 'system',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/index.vue'),
        meta: {
          title: '首页',
          icon: 'home',
          activeMenu: '/system'
        }
      },
      {
        path: '/useExplain',
        name: 'useExplain',
        component: () => import(/* webpackChunkName: "userManage" */ '@/views/system/useExplain/index.vue'),
        meta: {
          title: '使用说明',
          hidden: true
        }
      },
      {
        path: '/useExplainDetail',
        name: 'useExplainDetail',
        component: () => import(/* webpackChunkName: "tenantStory" */ '@/views/system/useExplain/detail.vue'),
        meta: {
          title: '使用说明详情',
          hidden: true
        }
      },
    ]
  },
  {
    path: '/download',
    component: Layout,
    meta: {
      title: '报告生成',
      activeMenu: '/download',
      sort: 25
    },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "download" */ '@/views/download/index.vue'),
        meta: {
          title: '报告生成',
          icon: 'down',
          activeMenu: '/download',
          code: 16
        }
      }
    ]
  },
  {
    path: '/preview',
    component: () => import(/* webpackChunkName: "print" */ '@/views/print/preview.vue'),
    meta: {
      hidden: true,
      title: '预览报告',
      activeMenu: '/print',
      sort: 11
    }
  },
  {
    path: '/print',
    component: () => import(/* webpackChunkName: "print" */ '@/views/print/index.vue'),
    beforeEnter: async (to: Route, from: Route, next: Function) => {
      try {
        const params: ParsedQs = parse(window.location.href)
        console.log('/print router params', params)
        window.sessionStorage.setItem('tenantId', params.tenantId as string)
        await CommonMudule.SET_USER_GENDER(params.gender as string)
        await CommonMudule.SET_USER_NAME(params.customerName as string)
        await UserModule.SET_TOKEN(params.token as string)
        await CommonMudule.SET_CUSTOMERID_VAl(params.customerId)
        await UserModule.UserDetailAction(params.userId as string)
        await CommonMudule.getImgSourceAction()
        await next()
      } catch (e) {
        next(false)
      }
    },
    meta: {
      hidden: true,
      title: '报告生成',
      activeMenu: '/print',
      sort: 12
    }
  },
  {
    path: '/userManage',
    activeMenu: '/userManage',
    meta: {
      hidden: true,
      title: '客户管理',
      icon: 'customer',
      activeMenu: '/userManage',
      sort: 13
    },
    component: Layout,
    children: [
      {
        path: '/select',

        component: () => import(/* webpackChunkName: "userManage" */ '@/views/login/user/index.vue'),
        meta: {
          title: '客户管理',
          icon: 'customer',
          activeMenu: '/userManage'
        }
      },
      {
        path: '/changePwd',
        component: () => import(/* webpackChunkName: "userManage" */ '@/views/login/user/changePwd.vue'),
        meta: {
          title: '修改密码',
          hidden: true
        }
      },
      {
        path: '/changeAvatar',
        component: () => import(/* webpackChunkName: "userManage" */ '@/views/login/user/changeAvatar.vue'),
        meta: {
          title: '修改头像',
          hidden: true
        }
      },
      {
        path: '/userStory',
        name: '/userStory',
        component: () => import(/* webpackChunkName: "userManage" */ '@/views/login/user/userStory/index.vue'),
        meta: {
          title: '用户选择故事线',
          hidden: true
        }
      },
      {
        path: '/userStoryDetail',
        name: 'userStoryDetail',
        component: () => import(/* webpackChunkName: "tenantStory" */ '@/views/login/user/userStory/userStoryDetail.vue'),
        meta: {
          title: '故事线详情',
          hidden: true
        }
      },
      {
        path: '/changePermission',
        component: () => import(/* webpackChunkName: "userManage" */ '@/views/login/user/changePermission.vue'),
        meta: {
          title: '许可证切换',
          hidden: true
        }
      },
      {
        path: '/demo',
        component: () => import(/* webpackChunkName: "userManage" */ '@/components/TsTable/demo.vue'),
        meta: {
          title: 'demo',
          hidden: true
        }
      }
    ]
  }
]
